<template>
  <div class="integrations-access" data-testid="integrations-access-panel">
    <div
      v-if="isReadOnly"
      class="integrations-access__notice"
      role="note"
      data-testid="integrations-read-only-notice"
    >
      <v-icon size="20" class="integrations-access__icon" aria-hidden="true"
        >mdi-lock-outline</v-icon
      >
      <p class="integrations-access__text">{{ READ_ONLY_NOTICE }}</p>
    </div>
    <slot :status="status" :can-manage="canManage" :loading="loading" />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { getIntegrationsStatus } from "@/api/integrationsAPI";
import { useNotificationStore } from "@/store/pinia/notifications";

const READ_ONLY_NOTICE =
  "Only the Account Owner or Co-Owner can connect or disconnect integrations. You can see their status here.";

const notifications = useNotificationStore();

const status = ref(null);
const loading = ref(true);

// Fail closed: until the API confirms can_manage === true, no action is offered.
const canManage = computed(() => status.value?.can_manage === true);
const isReadOnly = computed(() => !loading.value && status.value?.can_manage === false);

async function loadStatus() {
  loading.value = true;
  try {
    const accountId = localStorage.getItem("currentAccountID");
    const response = await getIntegrationsStatus(accountId);
    status.value = response?.data ?? null;
  } catch (error) {
    status.value = null;
    notifications.error("Couldn't load integration status");
    console.error("Integrations status request failed:", error);
  } finally {
    loading.value = false;
  }
}

onMounted(loadStatus);
defineExpose({ reload: loadStatus });
</script>

<style scoped>
.integrations-access__notice {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding: 16px;
  border-radius: 8px;
  background: #f9fafb;
}

.integrations-access__icon {
  color: #475467;
}

.integrations-access__text {
  margin: 0;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #475467;
}
</style>
